import React from 'react';

import { getCrmIntegrations } from '~/common/constants/integrations';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useSearchParams } from '~/hooks/router';
import { useIntl } from 'react-intl';

import IntegrationCardList from './IntegrationCardList';

function CrmIntegrationCardList() {
  const [_, setTabValue] = useSearchParams('tab'); // eslint-disable-line no-unused-vars
  const multipleSFDCIntegrations = useFlag(
    FlagType.SupportMultipleSFDCOrganizations,
  );
  const intl = useIntl();

  const integrationCards = Object.values(getCrmIntegrations()).map(
    (integration) => ({
      ...integration,
      inactiveMessage: false,
      enableStatusDetails: false,
      action: {
        onClick: () =>
          setTabValue(multipleSFDCIntegrations ? 'sales' : 'third-party'),
        text: intl.formatMessage({
          id: 'CrmIntegrationCardList.seeIntegration',
          defaultMessage: 'See integration',
          description:
            'Button text to see the CRM integration details | maxLength=60',
        }),
      },
    }),
  );

  return <IntegrationCardList integrationCards={integrationCards} />;
}

export default CrmIntegrationCardList;
